export default function ArchHero() {
  return (
    <section className="relative w-full overflow-hidden bg-[#0f1117]" style={{ minHeight: '420px' }}>
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/dee193024d0d70063aa731606e53a816.jpg"
          alt="VergeOS Mimari Arkaplan"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      <div className="relative max-w-[1280px] mx-auto px-6 py-20 flex flex-col items-center justify-center text-center" style={{ minHeight: '420px' }}>
        <span className="inline-block text-xs font-semibold text-[#e8600a] uppercase tracking-widest mb-4 bg-[#e8600a]/10 border border-[#e8600a]/30 px-3 py-1 rounded-full">
          Mimari Genel Bakış
        </span>
        <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-5 leading-tight">
          Sanallaştırmanın <span className="text-[#e8600a]">Geleceği</span>
        </h1>
        <p className="text-lg text-gray-300 max-w-2xl mb-8 font-light">
          Geleneksel Sanallaştırma Platformunuzu Ultra Birleşik Altyapı Yazılımıyla Değiştirin — Daha az katman, daha düşük maliyet, daha fazla performans.
        </p>
      </div>
    </section>
  );
}
